module.exports = __webpack_public_path__ + "img/the-netherlands-ischemic-heart-disease-male.d5420dd6.png";